import Immutable from 'seamless-immutable';

export const filters = Immutable({
  providers: 'PROVIDER',
  organizations: 'ORGANIZATION',
  types: 'TYPES',
  status: 'STATUS',
  initialEvaluationDateRange: 'IE_DATE_RANGE',
  scheduleDateRange: 'SCHEDULE_DATE_RANGE',
  includeDischarged: 'INCLUDE_DISCHARGED',
});

export const sections = Immutable({
  assessments: 'AGGREGATE_ASSESSMENTS_LIST',
});
